import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { ResponseContentType, Headers, Http } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { map } from "rxjs/operators";

@Injectable()
export class AnalystProfileService {
  constructor(private httpClient: HttpClient, private http: Http) { }

  getAnalystDetails(id: string) {
    return this.httpClient.get(`UserRoleViews/get-analyst-profile/${id}`);
  }

  update_AnalystDetails(id: string, analystDetails){
    return this.httpClient.patch(`/AnalystDetails/update-analyst-details/${id}`, analystDetails)
  }

  updateDetailsOfAnalyst(id: string, analystDetails) {
      return this.httpClient.patch(`users/${id}`, analystDetails);
  }

  updateAnalystContactDetails(id: string, analystDetails){
    return this.httpClient.patch(`AnalystDetails/update-analyst-contact-info/${id}`,analystDetails)
  }

  updateAnalyst(id: string,analystDetails){
    return this.httpClient.patch(`AnalystDetails/update-analyst-profile/${id}`,analystDetails)
  }

  getAnalyst_Details() {
    return this.httpClient.get(`AnalystDetails`);
  }

  getAnalystCurrentSkills(filter: any, analystId: string) {
    return this.httpClient.get(`Skills/analyst/${analystId}`, {
      params: filter
    });
  }

  getAnalystFollowers(filter?: any) {
    return this.httpClient.get("AnalystFollowers/getList", {
      params: filter
    });
  }
  

  getAnalystHighlights(filter?: any) {
    return this.httpClient.get("AnalystHighlights/getList", {
      params: filter
    });
  }

  getAllSkills(filter) {
    return this.httpClient.get("Skills/getList", { params: filter });
  }

  getAnalyticsOfferings(id: string) {
    return this.httpClient.get(`AnalystDetailViews/analyst-detail/${id}`);
  }

  getAnalystServices(filter){
    return this.httpClient.get("Services/getList?", { params: filter });
  }

  getAnalystServicesById(filter,id: string){
    return this.httpClient.get(`Services/${id}`,{params: filter});
  }

  getAnalystFocusAreas(filter){
    return this.httpClient.get("FocusAreas/getList?", { params: filter });
  }

  getAnalystMarketData(filter){
    return this.httpClient.get("Markets/getList?", { params: filter });
  }
  getAnalystIndustries(filter){
    return this.httpClient.get("Industries/getList?", { params: filter });
  }

  getDashboardStatistics(id: string) {
    return this.httpClient.get(`users/${id}/dashboard`);
  }

  addSkill(query) {
    return this.httpClient.post("Skills/add-skill", {}, { params: query });
  }

  removeFollower(query) {
    return this.httpClient.delete("AnalystFollowers/follower", {
      params: query
    });
  }

  updateAnalystDetails(id: string, analystDetails) {
    return this.httpClient.patch(`AnalystDetails/update-analyst-details/${id}`, analystDetails);
  }

  getStatesList(countryId: string) {
    return this.httpClient.get(`States/getStates/${countryId}`);
  }

  getCitiesList(stateId: string) {
    return this.httpClient.get(`Cities/getCities/${stateId}`);
  }

  getAnalystCompanyInfo(analystId: string){
    return this.httpClient.get(`AnalystDetailViews/analyst-detail/${analystId}`);
  }

  updateAnalystCompanyDetails(analystId: string, analystDetails) {
    return this.httpClient.patch(`AnalystDetails/update-analyst-company-info/${analystId}`, analystDetails);
  }

  updateAnalystOfferings(analystId: string,analystDetails){
    return this.httpClient.patch(`AnalystDetails/update-analyst-offerings/${analystId}`, analystDetails);
  }
  getAnalystOrganizationInfo(){
    return this.httpClient.get(`Organizations?filter={"isActive":true}`);
  }
  getAnalystJobTitles(){
    return this.httpClient.get(`/JobTitles/getList?`);
  }
  getAnalystBLogs(id: string) {
    return this.httpClient.get(`BlogUserMappings/analyst-blog/${id}`);
  }

  getImageURL(image) {
    return this.httpClient.post("Reports/upload-image", image);
  }

  saveReport(image) {
    return this.httpClient.patch("Reports", image);
  }

  getPDFURL(pdf) {
    return this.httpClient.post("Reports/upload-pdf", pdf);
  }

  getImage(imageUrl: string): Observable<File> {
    return this.http
      .get(imageUrl, { responseType: ResponseContentType.Blob })
      .pipe(map((response: any) => response.blob()));
  }

  changeReportStatus(query, data?) {
    return this.httpClient.patch("Reports/change-status", data, {
      params: query
    });
  }
  saveUpcomingReport(report) {
    return this.httpClient.post("UpcomingReports", report);

  }
  updateUpcomingReport(id, report) {
    return this.httpClient.patch(`UpcomingReports/${id}`, report);

  }
  deleteUpcomingReport(id) {
    return this.httpClient.delete(`UpcomingReports/${id}`);
  }
  deleteReport(id) {
    return this.httpClient.delete(`Reports/${id}`);
  }
  deleteSkill(query) {
    return this.httpClient.delete(`Skills/remove-skill`, { params: query });
  }
  getUpcomingReport(filter) {
    return this.httpClient.get(`/UpcomingReports/analyst-report`, { params: filter });

  }

  // report user
  reportFollower(followerUserId: string, message: Object){
    return this.httpClient.post(`AnalystFollowers/report?followerUserId=${followerUserId}`, message);
  }

  getWorkingHour() {
    return this.httpClient.get(`AnalystTimings/time-settings-list`);
  }

  updateCalendarConfig(status: boolean) {
    return this.httpClient.patch(`AnalystTimings/set-ecosystm-calendar?considerEcosystmTiming=${status}`, {});
  }

  addTimeSlot(id: string, slot: any) {
    return this.httpClient.post(`AnalystTimings/update-time?analystTimingConfigurationMasterId=${id}`, slot);
  }

  updateTimeSlot(id: string, slot: Object) {
    return this.httpClient.patch(`AnalystTimings/update-time-on-day?analystTimingId=${id}`, slot);
  }

  removeTimeSlot(id: string) {
    return this.httpClient.delete(`AnalystTimings/time-settings?analystTimingId=${id}`);
  }
  uploadDocument(formData): Observable<any> {
    const headerInfo = new HttpHeaders({ 'Content-Type': 'multipart/form-data;'});
    const options = { headers: headerInfo };
    return this.httpClient.post(`Reports/upload`, formData, options);
  }
  inviteTechVendor(email: string, userId: string, accessToken: string) {
    const params = new HttpParams()
      .set("emailId", email)
      .append("id", userId)
      .append("access_token", accessToken);
    return this.httpClient.get("users/tech-vendor-invitation", {
      params: params
    });
  }
  inviteTechBuyer(email: string, userId: string, accessToken: string) {
    const params = new HttpParams()
      .set("emailId", email)
      .append("id", userId)
      .append("access_token", accessToken);
    return this.httpClient.get("users/tech-buyer-invitation", {
      params: params
    });
  }
  getEcosystmStaffDetails(filters) {
    let filter = new HttpParams().set("filter", JSON.stringify(filters));
    return this.httpClient.get(`UserRoleViews`, { params: filter });
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/tech-analyst/shared/services/analyst-profile.service.ts